
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.5 16.25h15v1.25h-15v-1.25zm7.5-1.875A4.375 4.375 0 015.625 10V3.125h1.25V10a3.125 3.125 0 106.25 0V3.125h1.25V10A4.375 4.375 0 0110 14.375z","fill":"#585858"}})])
          )
        }
      }
    